import { app } from '@/main.js'
import { NOTIFY_TYPE } from '@GUTIL/hardCode'
const _isOperator = process.env.VUE_APP_FOLDER_NAME === 'XNB_XO'

const sleep = ms => {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

const state = {
  systemMessages: [],
  MessageOpenedKey: 'message_opened',
  systemAnnouncementStatus: false, // 公告狀態
  systemAnnouncementOpened: false, // 公告已顯示狀態
  systemMaintenanceStatus: false, // 維護狀態
  addressNotifyMD5: '' // 項目地址更動公告狀態
}

const actions = {
  async [_GM.CHECK_ADDRESS_NOTIFY]({ commit, dispatch }, md5) {
    if (state.addressNotifyMD5 !== md5) {
      commit('SET_MESSAGE_STATUS', { key: 'addressNotifyMD5', status: md5 })
      await dispatch('API_GET_ADDRESS_NOTIFY_LIST')
    }
  },
  async [_GM.HANDLE_SYSTEM_ANNOUNCEMENT]({ state, commit, dispatch }, status) {
    if (status == 1 && !state.systemAnnouncementStatus) {
      commit('SET_MESSAGE_STATUS', {
        key: 'systemAnnouncementStatus',
        status: true
      })
      const isMessageOpened =
        localStorage.getItem(state.MessageOpenedKey) === 'true'
      // commit(_GM.SET_SYSTEM_ANNOUNCE_OPENED, isMessageOpened)
      !isMessageOpened && (await dispatch('API_GET_SYSTEM_INFO'))
    }
  },
  [_GM.CHECK_SYSTEM_MAINTENANCE]({ commit }, status) {
    if (status == 1) {
      // commit('SET_MESSAGE_STATUS', 'systemMaintenanceStatus', true)
      app.$router.push('/Maintain')
    }
  },
  async [_GM.REMOVE_MESSAGE]({ commit, dispatch }, index) {
    const payload = { ...state.systemMessages[index] }
    if (payload.notifyType == NOTIFY_TYPE.SYSTEM_ANNOUNCEMENT) {
      commit(_GM.SET_SYSTEM_ANNOUNCE_OPENED, true)
    } else if (payload.notifyType == NOTIFY_TYPE.ADDRESS) {
      await dispatch('API_REMOVE_ADDRESS_NOTIFY', index)
    }
    commit(_GM.REMOVE_MESSAGE, index)
  },
  async API_GET_SYSTEM_INFO({ commit }) {
    let message = ''
    const { allSettings } = await app.$graphqlProvider.getSystemInfo()
    if (_isOperator) {
      message = allSettings.system_maintenance_operator_announcement
    } else {
      message = allSettings.system_maintenance_fenko_announcement
    }
    commit('ADD_MESSAGES', {
      messagePackage: [{ message }],
      unShift: true,
      notifyType: NOTIFY_TYPE.SYSTEM_ANNOUNCEMENT
    })
  },
  async API_GET_ADDRESS_NOTIFY_LIST({ commit }) {
    try {
      const {
        allAddressNotifyList
      } = await app.$graphqlProvider.getAllAddressNotifyList()

      // 濾除相同的公告訊息
      let filterMsgs = []
      const addressNotifies = allAddressNotifyList.data
      addressNotifies.forEach(notify => {
        const message = app.$t('i18n_notify_addr_changed', {
          sectionName: notify.section_name
        })
        const existMsgs = state.systemMessages.map(sysMsg => sysMsg.content)
        if (existMsgs.indexOf(message) == -1) {
          filterMsgs.push({ id: notify.id, message })
        }
      })

      commit('ADD_MESSAGES', {
        messagePackage: filterMsgs,
        notifyType: NOTIFY_TYPE.ADDRESS
      })
    } catch (e) {
      console.log(e)
    }
  },
  async API_REMOVE_ADDRESS_NOTIFY(_, index) {
    try {
      const payload = state.systemMessages[index]
      await app.$graphqlProvider.deleteAddressNotify({ id: payload.id })
    } catch (e) {
      console.log(e)
    }
  }
}

const mutations = {
  RESET_MESSAGE(state) {
    state.systemMessages = []
    state.systemAnnouncementStatus = false
    state.systemAnnouncementOpened = false
    state.systemMaintenanceStatus = false
    state.addressNotifyMD5 = ''
    localStorage.setItem('message_opened', false)
  },
  ADD_MESSAGES(
    state,
    {
      messagePackage,
      unShift = false,
      notifyType = NOTIFY_TYPE.SYSTEM_ANNOUNCEMENT
    }
  ) {
    const payload = messagePackage.map(row => {
      return { content: row.message, notifyType, id: row.id }
    })
    if (unShift) {
      state.systemMessages = [...payload, ...state.systemMessages]
    } else {
      state.systemMessages = [...state.systemMessages, ...payload]
    }
  },
  [_GM.REMOVE_MESSAGE](state, index) {
    state.systemMessages.splice(index, 1)
  },
  SET_MESSAGE_STATUS(state, { key, status }) {
    if (!Object.prototype.hasOwnProperty.call(state, key)) return

    state[key] = status
  },
  [_GM.SET_SYSTEM_ANNOUNCE_OPENED](state, val) {
    state.systemAnnouncementOpened = val
    !val && (state.systemAnnouncementStatus = false) //只有登入頁才會關掉，關掉順便把狀態也關了
    localStorage.setItem('message_opened', val)
  }
}

const getters = {
  addressNotifyStatus: state => state.addressNotifyStatus,
  systemMessages: state => state.systemMessages,
  systemAnnouncementStatus: state => state.systemAnnouncementStatus,
  systemMaintenanceStatus: state => state.systemMaintenanceStatus,
  systemAnnouncementOpened: state => state.systemAnnouncementOpened
}

export default {
  state,
  actions,
  mutations,
  getters
}
